import { noop } from '@/shared/utils/noop';

export type ThemeMode = 'system' | 'light' | 'dark';

export const THEME_MODE_STORAGE_KEY = 'theme.mode';
const LEGACY_PERSIST_KEY = 'persist:theme';

const VALID_MODES: ThemeMode[] = ['system', 'light', 'dark'];

export function readStoredMode(): ThemeMode {
  const stored = localStorage.getItem(THEME_MODE_STORAGE_KEY);
  if (stored && (VALID_MODES as string[]).includes(stored)) {
    return stored as ThemeMode;
  }

  try {
    const legacy = localStorage.getItem(LEGACY_PERSIST_KEY);
    if (legacy) {
      const parsed: unknown = JSON.parse(legacy);
      if (
        parsed !== null &&
        typeof parsed === 'object' &&
        'mode' in parsed &&
        typeof (parsed as Record<string, unknown>)['mode'] === 'string' &&
        (VALID_MODES as string[]).includes((parsed as Record<string, unknown>)['mode'] as string)
      ) {
        const migratedMode = (parsed as Record<string, unknown>)['mode'] as ThemeMode;
        localStorage.setItem(THEME_MODE_STORAGE_KEY, migratedMode);
        localStorage.removeItem(LEGACY_PERSIST_KEY);
        return migratedMode;
      }
    }
  } catch {
    noop();
  }

  return 'system';
}

export function getSystemPrefersDark(): boolean {
  if (globalThis.window === undefined || typeof globalThis.window.matchMedia !== 'function') {
    return false;
  }
  const mediaQuery = globalThis.window.matchMedia('(prefers-color-scheme: dark)');
  return mediaQuery?.matches ?? false;
}
